export default {"src":"/_next/static/media/capW.16f94454.svg","height":24,"width":32,"blurWidth":0,"blurHeight":0};